import { freightDeliveryAccessorialPresetIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const deleteFreightDeliveryAccessorialPreset = {
  name: "deleteFreightDeliveryAccessorialPreset" as const,
  input: z.object({ id: freightDeliveryAccessorialPresetIdFormat.schema }),
  output: z.object({}),
};
